import SuccessMessage from "@/components/SuccessMessage/SuccessMessage.vue"
import axios from "axios";
import {mapGetters} from "vuex";
export default {
    name: 'ConfirmEmail',
    components: {SuccessMessage},
    data() {
        return {
            validToken: false,
        }
    },
    created() {
        this.check()
    },
    methods: {
        check() {
            this.$store.dispatch('changeActivate', this.$route.params.token).then(res => {
                if (res.status === 200) {
                    this.validToken = true
                    this.$router.push('/my-gates')
                }

            })

        },
    },
    computed: {
        ...mapGetters(['getEndTrial','getTrialPlanPeriod'])
    }
}
